import { createAction, props } from '@ngrx/store';

import { createFailure, createSuccess } from '../utils/action-utils';
import { Threats } from './models/Threats';

// Get Threats Actions //
const getThreatsKey = '[Threats] Get Threats';
export const getThreats = createAction(getThreatsKey);
export const getThreatsSuccess = createAction(
  createSuccess(getThreatsKey),
  props<{ threats: Threats[] }>(),
);
export const getThreatsFailure = createAction(
  createFailure(getThreatsKey),
  props<{ error: any }>(),
);

// Run Scan Threats Actions //
const runScanThreatsKey = '[Threats] Run Scan';
export const runScanThreats = createAction(runScanThreatsKey);
export const runScanThreatsSuccess = createAction(
  createSuccess(runScanThreatsKey),
);
export const runScanThreatsFailure = createAction(
  createFailure(runScanThreatsKey),
  props<{ error: any }>(),
);

// Calculate Threat Risk Actions //
const calculateThreatRiskKey = '[Threats] Calculate Risk';
export const calculateThreatRisk = createAction(
  calculateThreatRiskKey,
  props<{ threatId: string }>(),
);
export const calculateThreatRiskSuccess = createAction(
  createSuccess(calculateThreatRiskKey),
  props<{ threatId: string }>(),
);
export const calculateThreatRiskFailure = createAction(
  createFailure(calculateThreatRiskKey),
  props<{ error: any }>(),
);
